import React, { useState, useEffect } from "react";
import { DatePicker, Modal, message } from "antd";
import http from "@/utils/http";
import api from "@/utils/api";
import { CustomTable } from "@/hocComponents";
import commonFn from "@/utils/commonFn";
const UnitDetailDrawer = ({ 
  visible, 
  onClose, 
  drawerType, 
  record, 
}) => {
  const [loading, setLoading] = useState(false);
  const [detailData, setDetailData] = useState([]);

  const [tableHead, setTableHead] = useState({});
  const [propTypeOptions, setPropTypeOptions] = useState([]);
  const [unitTypeOptions, setUnitTypeOptions] = useState([]);
  const [detail,setDetail]= useState([]);
  const fetchPropertyTypes = async () => {
    try {
      const res = await http.get(api.getPropTypeList);
      if (res?.code === "1") {
        const options = res.data.map((item) => ({
          label: item?.name,
          value: item?.code,
        }));
        setPropTypeOptions(options);
      }
    } catch (error) {
      console.error("Failed to load property types:", error);
    }
  };
  const fetchUnitTypes = async () => {
    try {
      const res = await http.get(api.getUnitTypeList);
        const options = res.map((item) => ({
          label: item?.value,
          value: item?.value,
        }));
        setUnitTypeOptions(options);
    } catch (error) {
      console.error("Failed to load Unit types:", error);
    }
  };

const getTableListFn = async (page, count, tableHeadTemp = {}) => {
  if (!record) return;
  setLoading(true);
  try {
    let params = {
      page: page || 1,
      count: count || 1000,
      propUnit: tableHeadTemp?.propUnit || "",
      address:tableHeadTemp?.address || "",
      propType: tableHeadTemp?.propType || "",
      unitType:tableHeadTemp?.unitType || "",
      bedBath: tableHeadTemp?.bedBath || "",
      rentChanges: tableHeadTemp?.rentChanges || "",
      vacantDate: tableHeadTemp?.vacantDate || "",
      orderField: tableHeadTemp?.orderField || "",
      orderType: tableHeadTemp?.orderType || "",
    };

    if (drawerType === "city") {
      params = {
        ...params,
        city: record.city,
      };
    } else if (drawerType === "area") {
      params = {
        ...params,
        city: "",
        groupId: record.id,
        supervisorId: "",
      };
    } else if (drawerType === "supervisor") {
      params = {
        ...params,
        city: "",
        groupId: "",
        supervisorId: record.id,
      };
    } else if (drawerType === "snapshot") {
      params = {
        ...params,
      };
    }
    const res = await http.post(api.getSnapshotByUnit, params);
    if (res?.code === "1" && res?.data) {
      setDetailData(
        res.data.list || []
      );
     setDetail(res.data)
    } else {
      message.error(res?.msg || "Failed to fetch detail data");
    }

  } catch (error) {
    console.error("Error fetching detail data:", error);
    message.error("Failed to fetch detail data");

  } finally {
    setLoading(false);
  }
};
  const tableFilterFn = (event, key, type = "Input") => {
    commonFn.tableFilterFn({
      event,
      key,
      type,
      setTableHead,
      getTableListFn,
      pageSize: 1000,
    });
  };

  const dateFilterFn = (dateString) => {
    setTableHead((prev) => {
      const updatedTableHead = {
        ...prev,
        vacantDate: dateString || undefined,
      };
      getTableListFn(1, 1000, updatedTableHead);
      return updatedTableHead;
    });
  };

  const stopDatePickerEvent = (e) => {
    e.stopPropagation();
  };

useEffect(() => {
  if (visible && record) {
        fetchPropertyTypes();
        fetchUnitTypes();
        getTableListFn();
  }
}, [visible, record, drawerType]);
  const handleClose = () => {
    setDetailData([]);
    setTableHead({});
    onClose();
  };

const getDetailColumns = () => {
  const columns = [
    {
      title: 'Prop-Unit',
      dataIndex: 'propUnit',
      key: 'propUnit',
      align: 'center',
      titleType: "Input",
      isSorter:true,
      onChange: (e) => tableFilterFn(e, "propUnit"),
    },
       {
      title: 'Address',
      dataIndex: 'address',
      key: 'address',
      align: 'center',
      titleType: "Input",
      isSorter:true,
      width:240,
      onChange: (e) => tableFilterFn(e, "address"),
    },
    {
      title: 'Property Type',
      dataIndex: 'propType',
      key: 'propType',
      align: 'center',
      width:100,
        titleType: "Select",
        isSorter:true,
        selectOptions: propTypeOptions,
        onChange: (value) => tableFilterFn(value, "propType", "Select"),
    },
    {
      title: 'Unit Type',
      dataIndex: 'unitType',
      key: 'unitType',
      align: 'center',
      width:80,
       titleType: "Select",
        isSorter:true,
        selectOptions: unitTypeOptions,
        onChange: (value) => tableFilterFn(value, "unitType", "Select"),
    },
    {
      title: 'Bd | Bth',
      dataIndex: 'bedBath',
      key: 'bedBath',
      align: 'center',
      width:80,
       titleType: "Input",
         isSorter:true,
        onChange: (e) => tableFilterFn(e, "bedBath"),
    },
    {
      title: 'S.F.',
      dataIndex: 'sqFeet',
      key: 'sqFeet',
      align: 'center',
      width:80,
    },
    {
      title: 'Rent Changes',
      dataIndex: 'rentChanges',
      key: 'rentChanges',
      align: 'center',
      width:100,
        isBracketAmountFlag: true,
       titleType: "Input",
       isSorter:true,
        onChange: (e) => tableFilterFn(e, "rentChanges"),
    },
    {
      title: 'Old Rent',
      dataIndex: 'oldRent',
      key: 'oldRent',
      align: 'center',
       width:100,
      isBracketAmountFlag: true,
    },
    {
      title: 'New Rent',
      dataIndex: 'newRent',
      key: 'newRent',
      align: 'center',
      isBracketAmountFlag: true,
    },
    {
      title: 'Deposit',
      dataIndex: 'deposit',
      key: 'deposit',
      align: 'center',
      isBracketAmountFlag: true,
    },
    {
      title: 'Total',
      dataIndex: 'total',
      key: 'total',
      align: 'center',
      isBracketAmountFlag: true,
    },
    {
      title: 'Vacant Date',
      dataIndex: 'vacantDate',
      key: 'vacantDate',
      align: 'center',
      isSorter:true,
    },
    {
      title: 'Vacant Days',
      dataIndex: 'vacantDays',
      key: 'vacantDays',
      align: 'center',
      isSorter:true,
      width:80,
    },
    {
      title: 'Credit Status',
      dataIndex: 'creditStatus',
      key: 'creditStatus',
      align: 'center',
      width:100,
    },
    {
      title: 'Credit Date',
      dataIndex: 'creditDate',
      key: 'creditDate',
      align: 'center',
      width:100,
    },
  ];
  if (drawerType !== 'supervisor') {
    columns.push({
      title: 'Supervisor',
      dataIndex: 'supervisor',
      key: 'supervisor',
      align: 'center',
    });
  }

  return columns;
};

const getModalTitle = () => {
  if (!record) return 'Unit Details';
  
  const typeMap = {
    'city': `City Units - ${record.name || record.city}`,
    'area': `Area Units - ${record.name}`,
    'supervisor': `Supervisor Units - ${record.name || record.supervisor}`,
    'snapshot': 'Unit Details',
  };
  const baseTitle = typeMap[drawerType] || 'Unit Details';
  
  const summary = detail?.summary;
  if (summary) {
    const parts = [];
    if (summary.totalProperties) parts.push(`${summary.totalProperties} Properties`);
    if (summary.totalUnits) parts.push(`${summary.totalUnits} Units`);
    if (summary.vacancyUnits !== undefined) parts.push(`Vacancy: ${summary.vacancyUnits} Units`);
    if (summary.evictionUnits !== undefined) parts.push(`Eviction: ${summary.evictionUnits} Units`);
    
    if (parts.length > 0) {
      return `${baseTitle} - ${parts.join(', ')}`;
    }
  }
  return baseTitle;
};

  return (
    <Modal
      title={getModalTitle()}
      open={visible}
      onCancel={handleClose}
      footer={null}
      width="80%"
      destroyOnClose
      maskClosable={false}
      centered
      styles={{ body: { padding: '16px 0' } }}
    >
    <CustomTable
     columns={getDetailColumns()}
     tableList={detailData}
     tableLoading={loading}
     rowKey="unitId"
     size="small"
     setTableHead={setTableHead}
     getTableListFn={getTableListFn}
     pagination={false}
     scroll={{ x: "max-content",
      y: "calc(80vh - 200px)" }}/>
    </Modal>
  );
};

export default UnitDetailDrawer;
